import { getInjector } from '../../utils/getInjector';
import { getTrackItem, flatCartItemsWithAddon } from './utils';
import slEventBus, { eventMetaMap } from '../../../../utils/slEventBus';

export const onTrackAddAddOnItem = async (payload) => {
  const { addOnItem, eventId, cartData } = payload;
  const injector = await getInjector();
  const Analytics = injector.get('Analytics');
  const gaService = injector.get('gaService');
  const productService = injector.get('productService');
  const $filter = injector.get('$filter');
  const cartService = injector.get('cartService');
  const trackerService = injector.get('trackerService');
  const slFeatureService = injector.get('slFeatureService');
  const $rootScope = injector.get('$rootScope');
  const mainConfig = injector.get('mainConfig');

  const { product_id, quantity, variation_id, type } = addOnItem;
  const flattenedItems = flatCartItemsWithAddon(cartData.items);

  // General Event
  trackerService.track({
    type: trackerService.generalEventType.ADD_TO_CART,
    data: {
      items: [
        {
          product: addOnItem.product,
          value: addOnItem.price.dollars,
          quantity: addOnItem.quantity,
          variationSelected: null,
        },
      ],
      eventId,
    },
  });

  // This event is for CST usage
  // see card SL-23292
  if (slFeatureService.hasFeature('data_layer_info')) {
    $rootScope.$emit('add.addon.item.to.cart', [
      {
        title: addOnItem.product.title_translations,
        sku: addOnItem.product.sku,
        currency: mainConfig.merchantData.base_currency_code,
        quantity: 1,
        price: addOnItem.price.dollars,
      },
    ]);
  }

  // Shoplytics
  cartService.tracking(
    trackerService.userActionTypes.ADD_ITEM,
    getTrackItem(product_id, variation_id, type, flattenedItems),
  );

  // Google Analysis
  if (Analytics.configuration.enhancedEcommerce) {
    // Sync up with old logic from directives.products.form.addon_products.js
    try {
      gaService.setUserId();

      Analytics.addProduct(
        productService.getSku(
          product_id,
          addOnItem.product.sku,
          addOnItem.variation,
        ),
        $filter('translateModel')(addOnItem.product.title_translations),
        '',
        '',
        productService.getVariationName(addOnItem.variation),
        cartService.getItemPrice(addOnItem)?.dollars?.toString(),
        quantity.toString(),
        '',
        '0',
      );
      Analytics.trackCart('add');
      // eslint-disable-next-line no-empty
    } catch (e) {}
  }

  // for storefront sdk
  slEventBus.emit(eventMetaMap.cart.itemAdded, cartData);
};
